import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  Textarea,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { CloseCircleOutline as CloseCircle } from '@aslanpay/portal-common-lib';

import { AddCategoryModalProps } from './AddCategoryModal.types';

const CATEGORY_NAME_MAX = 40;
const CATEGORY_DESCRIPTION_MAX = 100;

function AddCategoryModal({ isOpen, onClose, onSave, isSaving }: AddCategoryModalProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const clearFields = () => {
    setName('');
    setDescription('');
  };

  const handleClose = () => {
    onClose();
    clearFields();
  };

  // reset fields from parent component when modal is closed
  useEffect(() => {
    if (!isOpen) {
      clearFields();
    }
  }, [isOpen]);

  const handleSave = () => {
    onSave({ name: name.trim(), description: description.trim() || null });
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <Text as="h6">Add New Category</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircle boxSize="30px" />}
              aria-label="Close add category modal"
              onClick={handleClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <FormControl mb="20px" isRequired>
            <FormLabel>Category Name</FormLabel>
            <Input
              placeholder="e.g., Health & Wellbeing"
              maxLength={CATEGORY_NAME_MAX}
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <Text textAlign="right" textStyle="extraSmallMedium" color="brand.mediumGray2" mt="4px">
              {name.length}/{CATEGORY_NAME_MAX}
            </Text>
          </FormControl>
          <FormControl>
            <FormLabel>Description</FormLabel>
            <Textarea
              placeholder="Brief description of this category..."
              maxLength={CATEGORY_DESCRIPTION_MAX}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              resize="none"
              rows={4}
            />
            <Text textAlign="right" textStyle="extraSmallMedium" color="brand.mediumGray2" mt="4px">
              {description.length}/{CATEGORY_DESCRIPTION_MAX}
            </Text>
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button size="md" onClick={handleSave} isLoading={isSaving} isDisabled={!name.trim()}>
            Save Category
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default AddCategoryModal;
